import { errorLog } from '@/utils/logger';
import createApi from '@/services/Api';

function SpecialistKeepAlive() {
  let currentTimer = null;
  const api = createApi();

  const init = () => {
    clearTimeout(currentTimer);

    dispatchLifeSign();

    currentTimer = setTimeout(init, 30000);
  };

  const stop = () => {
    clearTimeout(currentTimer);
  };

  const dispatchLifeSign = async () => {
    const endpoint = `/profissional-saude/profissionais/plantoes/online`;
    try {
      await api.post(endpoint);
    } catch (err) {
      errorLog(err);
    }
  };

  return {
    init,
    stop,
  };
}

export default SpecialistKeepAlive();
